import React, { useRef, useState, useEffect } from "react";
import {
  RightOutlined,
  LeftOutlined,
  CarOutlined,
  HomeOutlined,
  UserOutlined,
  HeartOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { Carousel, Card, Empty } from "antd";

import "./styles/Dashboard.css";
import classNames from "classnames";

import { useTheme } from "../../store/context/theme-context";
import { useContext } from "react";
import { DashboardContext } from "../../store/context/DashboardContext";
import { useTenant } from "../../store/context/tenant-context";
import { formatDate } from "../../utils/helper/format";
import { useTranslation } from "react-i18next";

const PendingLoansCarousel = () => {
  const { t } = useTranslation();

  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);
  const [slidesToScroll, setSlidesToScroll] = useState(1);
  const [showArrows, setShowArrows] = useState(true);

  const { theme } = useTheme();
  const tenant = useTenant();
  const { pendingQuotes } = useContext(DashboardContext);
  console.log("pendingQuotes", pendingQuotes);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 480) {
        setSlidesToShow(1);
        setSlidesToScroll(1);
        setShowArrows(false);
      } else if (width < 768) {
        setSlidesToShow(2);
        setSlidesToScroll(2);
        setShowArrows(false);
      } else if (width < 1200) {
        setSlidesToShow(2);
        setSlidesToScroll(2);
        setShowArrows(false);
      } else {
        setSlidesToShow(3);
        setSlidesToScroll(3);
        setShowArrows(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const DashboardCarouselPrevArrow = ({ onClick }) => (
    <div
      style={{ backgroundColor: tenant.theme.colorPrimary }}
      className="absolute top-1/2 transform -translate-y-1/2 z-10 cursor-pointer w-10 h-10 rounded-full text-white flex items-center justify-center left-[-22px]"
      onClick={onClick}
    >
      <LeftOutlined className="text-lg" />
    </div>
  );

  const DashboardCarouselNextArrow = ({ onClick }) => (
    <div
      style={{ backgroundColor: tenant.theme.colorPrimary }}
      className="absolute top-1/2 transform -translate-y-1/2 z-10 cursor-pointer w-10 h-10 rounded-full  text-white flex items-center justify-center right-[-10px]"
      onClick={onClick}
    >
      <RightOutlined className="text-lg" />
    </div>
  );

  const handleQuoteClick = (quote) => {
    console.log("quote", quote);
    //navigate(`/${quote.policyNumber}`);
  };

  const handlePrevClick = () => {
    if (carouselRef.current) {
      carouselRef.current.prev();
      setCurrentIndex(currentIndex - slidesToScroll);
    }
  };

  const handleNextClick = () => {
    if (carouselRef.current) {
      carouselRef.current.next();
      setCurrentIndex(currentIndex + slidesToScroll);
    }
  };

  const getQuoteType = (type) => {
    switch (type) {
      case "personal":
        return "Personal Insurance";
      case "education":
        return "Education Insurance";
      case "motor":
        return "Motor Insurance";
      case "home":
        return "Home Insurance";
      case "medical":
        return "Medical Insurance";
      case "life":
        return "Life Insurance";
      default:
        return type;
    }
  };

  const getIconByType = (type) => {
    const iconColor =
      theme === "dark"
        ? "text-[#D3D3D3]"
        : tenant.theme.colorPrimary
        ? `text-[${tenant.theme.colorPrimary}]`
        : "";

    // const iconClass = classNames(iconColor, "w-6 h-6");

    switch (type) {
      case "personal":
        return <UserOutlined />;
      case "education":
        return <BookOutlined />;
      case "motor":
        return <CarOutlined />;
      case "home":
        return <HomeOutlined />;
      case "medical":
        return <HeartOutlined />;
      default:
        return <UserOutlined />;
    }
  };

  return (
    <div>
      <div
        className="p-0 rounded-md"
        style={{
          width: "335px",
          height: "76px",
        }}
      >
        <div className="mb-2">
          <p className="mb-5 text-lg font-semibold text-left">
            {t("My Pending Applications")}
          </p>
        </div>
        <div>
          <h6 className="text-sm font-normal">
            {t("Kindly view your ongoing Applications")}.
          </h6>
        </div>
      </div>
      <div
        className={`relative ${
          theme === "dark" ? "bg-dark text-white" : "bg-light text-black"
        }`}
      >
        {pendingQuotes?.length === 0 ? (
          <Empty description="No pending applications available" />
        ) : (
          <>
            <Carousel
              ref={carouselRef}
              draggable
              slidesToShow={slidesToShow}
              slidesToScroll={slidesToScroll}
              beforeChange={(current, next) => setCurrentIndex(next)}
              className="relative"
              dots={false}
            >
              {pendingQuotes?.map((quote, index) => (
                <div className="p-1" key={index}>
                  <Card
                    className={`rounded-lg p-1 shadow-md hover:cursor-pointer ${
                      theme === "dark"
                        ? "bg-gray-800 border-gray-600"
                        : "bg-white border-gray-300"
                    }`}
                    variant="borderless"
                    onClick={() => handleQuoteClick(quote)}
                  >
                    <div className="flex items-center gap-2">
                      <div
                        className={`rounded-full size-10 flex items-center justify-center ${
                          theme === "dark" ? "bg-gray-700" : "bg-gray-200"
                        }`}
                      >
                        {getIconByType(quote.type)}
                      </div>
                      <div className="flex-1 overflow-hidden">
                        <div
                          className={`font-semibold text-base truncate ${
                            theme === "dark" ? "text-gray-100" : "text-gray-800"
                          }`}
                          title={getQuoteType(quote.accountType)}
                        >
                          {getQuoteType(quote.accountType)}
                        </div>
                        <div
                          className={`${
                            theme === "dark" ? "text-gray-400" : "text-gray-600"
                          } text-sm`}
                        >
                          {"Loan"}
                        </div>
                        <div
                          className={`${
                            theme === "dark" ? "text-gray-400" : "text-gray-600"
                          } text-sm`}
                        >
                          {formatDate(quote.dateOpened)}
                        </div>
                        <div
                          className={`${
                            theme === "dark" ? "text-gray-400" : "text-gray-600"
                          } text-sm`}
                        >
                          {parseFloat(quote.loanAmount).toLocaleString(
                            "en-NG",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}{" "}
                          NGN
                        </div>
                      </div>
                    </div>
                    <div className="absolute transform -translate-y-1/2 top-1/2 right-2">
                      <RightOutlined
                        className={`text-xl ${
                          theme === "dark"
                            ? "text-gray-100"
                            : `text-[${tenant.theme.colorPrimary}]`
                        }`}
                      />
                    </div>
                  </Card>
                </div>
              ))}
            </Carousel>
            {showArrows && (
              <>
                {currentIndex > 0 && (
                  <DashboardCarouselPrevArrow onClick={handlePrevClick} />
                )}
                {currentIndex < pendingQuotes?.length - slidesToShow && (
                  <DashboardCarouselNextArrow onClick={handleNextClick} />
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PendingLoansCarousel;
